import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/socialConservation/pic3_icon1.png'
import _imports_1 from '@/assets/socialConservation/pic4_01.png'
import _imports_2 from '@/assets/socialConservation/pic4_02.png'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"kv\"><div class=\"caption\"><h1>小燕鷗保育</h1></div></div><section class=\"sect1\"><div class=\"ctx\"><p>每年 4~8 月，台灣都會迎接一群來自澳洲等地的嬌客飛到桃園、台中、宜蘭、花蓮和澎湖沿海繁殖渡冬，牠們就是二級海洋保育類野生動物「小燕鷗」。2024 年花蓮縣野鳥學會在和平電廠旁的堤外海灘，記錄到了 126 巢可愛的小燕鷗，顛覆一般人認為工業區附近生態環境不會好的印象，可能因為電廠設施的阻隔而讓外部干擾減少，又近鄰和平溪口而有淡水及食物來源，意外造就其良好的棲地環境。</p></div></section><section class=\"sect2\"><div class=\"ctx\"><div class=\"sectTit\">鄰近海灘發現成長中的小燕鷗</div><div class=\"gallery\"><div class=\"left\"><div class=\"imgContainer2-1\"></div></div><div class=\"right\"><div class=\"imgContainer2-2\"></div><div class=\"imgContainer2-3\"></div></div></div></div></section>", 3)
const _hoisted_4 = { class: "sect3" }
const _hoisted_5 = { class: "ctx" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "和平歡迎你 - 小燕鷗保育計畫", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "2024 年，小燕鷗首度被記錄出現在和平電廠旁的堤外海灘築巢育雛後，和平電力隨即與花蓮縣野鳥學會共同啟動保育行動，同時展開為期三年的監測計畫。在悉心守護之下，2025 年繁殖巢位數自 126 巢提升至 218 巢，繁殖成功數也由 59 巢增加至 107 巢。", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "sternula" }
const _hoisted_10 = { class: "tit" }
const _hoisted_11 = { class: "desp" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "thumbnail icon1" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "divLine" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("section", { class: "sect4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ctx" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
      /*#__PURE__*/_createElementVNode("p", null, "小燕鷗為海岸生態系重要的生物之一，僅在距離海岸約 1 公里內覓食，由於體型較其他海鳥更小，在捕食魚類的同時，也是猛禽夏季重要食物來源，因此，在河口與海洋間生態能量的交換中扮演重要角色。"),
      /*#__PURE__*/_createElementVNode("div", { class: "desp" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "tit" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-ellipsis-vertical" }),
          /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-ellipsis-vertical" }),
          /*#__PURE__*/_createTextVNode(" 回饋分享")
        ]),
        /*#__PURE__*/_createTextVNode(" 「起初認為鳥類都在樹上孵育雛鳥，原來小燕鷗是在海灘上啊！也因此了解海灘棲地面臨到人為干擾、流浪狗與車輛等威脅」。"),
        /*#__PURE__*/_createElementVNode("small", null, "（參與學員－江媽媽）")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "imgContainer4-1",
        src: _imports_1
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "imgContainer4-2",
        src: _imports_2
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "clear" }),
    /*#__PURE__*/_createElementVNode("iframe", {
      width: "560",
      height: "315",
      src: "https://www.youtube.com/embed/6vBYVCow2m4?si=hmWcofR82ZJ10OEH",
      title: "YouTube video player",
      frameborder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      referrerpolicy: "strict-origin-when-cross-origin",
      allowfullscreen: ""
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("article", null, [
      _hoisted_1,
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sternula, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx
              }, [
                _createElementVNode("div", {
                  class: "thumbnail",
                  style: _normalizeStyle(_ctx.setThumbnail(row.thumbnail))
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(row.tit), 1)
                ], 4),
                _createElementVNode("div", _hoisted_11, _toDisplayString(row.desp), 1)
              ]))
            }), 128)),
            _hoisted_12
          ]),
          _createVNode(_component_swiper, {
            modules: _ctx.modules,
            "slides-per-view": 1,
            "space-between": 1,
            autoplay: {delay:3000, disableOnInteraction:false},
            speed: 1000,
            loop: true,
            pagination: {clickable:true},
            onSwiper: _ctx.onSwiper,
            onSlideChange: _ctx.onSlideChange,
            class: "swiper"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, { class: "cover cover1" }),
              _createVNode(_component_swiper_slide, { class: "cover cover2" }),
              _createVNode(_component_swiper_slide, { class: "cover cover3" }),
              _createVNode(_component_swiper_slide, { class: "cover cover4" }),
              _createVNode(_component_swiper_slide, { class: "cover cover5" }),
              _createVNode(_component_swiper_slide, { class: "cover cover6" })
            ]),
            _: 1
          }, 8, ["modules", "onSwiper", "onSlideChange"]),
          _hoisted_13,
          _hoisted_14
        ])
      ]),
      _hoisted_15
    ]),
    _createVNode(_component_Footer)
  ], 64))
}